import { Button, Popover, PopoverTrigger, Stack, Text } from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';

export interface AppliesToCellProps {
	appliesTo: string[];
}

const PopoverContent = ({ models }: { models: string[] }) => {
	return (
		<div style={{ width: 240 }}>
			<Stack itemsSpacing='4'>
				{models.map((model) => (
					<Text key={model} size='bodySmall'>
						{model}
					</Text>
				))}
			</Stack>
		</div>
	);
};

const formatAppliesTo = (appliesTo: string[]): string => {
	if (appliesTo.length === 0) return 'All products';
	if (appliesTo.length === 1) return appliesTo[0] || 'All products';
	return `${appliesTo.length} models`;
};

export const AppliesToCell = ({ appliesTo }: AppliesToCellProps) => {
	const displayText = formatAppliesTo(appliesTo);
	const hasMultipleModels = appliesTo.length > 1;

	if (!hasMultipleModels) {
		return <Text size='bodySmall'>{displayText}</Text>;
	}

	return (
		<PopoverTrigger>
			<Button
				className='applies-to-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<Text size='bodySmall'>{displayText}</Text>
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent models={appliesTo} />
			</Popover>
		</PopoverTrigger>
	);
};
